import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name || u.email}`);
      const target = loc.state?.from || (
        ["super_admin","major_admin"].includes(u.role) ? "/admin" :
        (u.role === "venue_owner" || u.role === "staff") ? "/owner" : "/account"
      );
      nav(target);
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img src="https://images.unsplash.com/photo-1616668856493-9df876327739?w=1200" className="w-full h-full object-cover"/>
        <div className="absolute inset-0 hero-overlay"/>
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="text-[10px] uppercase tracking-widest-2 text-[color:var(--gold-2)]">Welcome back</div>
          <div className="font-display text-4xl mt-2">Your next Shubh Muhurat awaits.</div>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-md space-y-4" data-testid="login-form">
          <div>
            <h1 className="font-display text-4xl">Sign in</h1>
            <p className="text-sm text-neutral-600 mt-1">New here? <Link className="text-[color:var(--wine)] underline" to="/register">Create an account</Link></p>
          </div>
          <input type="email" required placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} className="w-full px-4 py-3 rounded-lg border" data-testid="login-email"/>
          <input type="password" required placeholder="Password" value={password} onChange={e=>setPassword(e.target.value)} className="w-full px-4 py-3 rounded-lg border" data-testid="login-password"/>
          <button disabled={busy} className="btn-wine w-full justify-center" data-testid="login-submit">{busy ? "Signing in…" : "Sign in"}</button>
          <div className="text-xs text-neutral-500 text-center">
            <Link to="/forgot-password" className="underline">Forgot password?</Link>
          </div>
          <div className="text-[11px] text-neutral-400 mt-6 p-3 rounded-lg bg-[color:var(--ivory-2)]">
            <div className="font-semibold mb-1">Demo accounts (dev):</div>
            <div>Super admin: superadmin@shubhmuhurat.in / SuperAdmin@2026</div>
            <div>Owner: owner@shagunlawns.com / Owner@2026</div>
            <div>Customer: customer@example.com / Customer@2026</div>
          </div>
        </form>
      </div>
    </div>
  );
}
